import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
const disableAllInputs = function (el, {
  value
}) {
  if (!value) return;
  const tags = ["input", "button", "textarea", "select", "a", "div"];
  tags.forEach(tagName => {
    const nodes = el.getElementsByTagName(tagName);
    for (const node of nodes) {
      var _context;
      if (!_includesInstanceProperty(_context = node.className).call(_context, "skip-disable-all-inputs")) {
        if (tagName === "a") {
          node.style = "pointer-events: none !important; color: #777777 !important";
        } else if (tagName === "div") {
          var _node$classList;
          if ((_node$classList = node.classList) != null && _node$classList.contains("tooltip-target")) {
            node.style = "pointer-events: none !important;";
          }
        } else {
          node.disabled = true;
          node.tabIndex = -1;
          node.className += " disabled";
        }
      }
    }
  });
};
export default {
  bind: disableAllInputs,
  componentUpdated: disableAllInputs
};